import {PhoneNumber} from '@dms/api/shared';

export type AssignPairedDeviceApiResponse = unknown;
export type AssignPairedDeviceApiArg = {
  pairedDeviceId: string;

  assignPairedDeviceRequestBody: AssignPairedDeviceRequestBody;
};
export type GetConfigurationProfileApiResponse = ConfigurationProfileResponseBody;
export type GetConfigurationProfileApiArg = {
  configurationProfileId: string;
};

export type GetPairedDeviceQrCodeApiResponse = string;
export type GetPairedDeviceQrCodeApiArg = {
  pairedDeviceId: string;
};
export type GetPairedDevicesListApiResponse = PairedDeviceResponseBody[];
export type GetPairedDevicesListApiArg = void;
export type PairDeviceApiResponse = {
  id: string;
};
export type UpdatePairedDeviceApiResponse = /** status 204  */ void;
export type UpdatePairedDeviceRequestBody = {
  name: string;
  branches: string[];
};
export type UpdatePairedDeviceApiArg = {
  pairedDeviceId: string;
  updatePairedDeviceRequestBody: UpdatePairedDeviceRequestBody;
};
export type PairDeviceApiArg = {
  pairDeviceRequestBody: PairDeviceRequestBody;
};
export type GetSignableDocumentApiResponse = SignableDocumentResponseBody;
export type GetSignableDocumentApiArg = {
  fileId: string;
};
export type GetSignableDocumentTransactionApiResponse = SignableDocumentTransactionResponseBody;
export type GetSignableDocumentTransactionApiArg = {
  fileId: string;
};
export type GetTransactionApiResponse = TransactionResponseBody;
export type GetTransactionApiArg = {
  transactionId: string;
};
export type KillTransactionApiResponse = unknown;
export type KillTransactionApiArg = {
  transactionId: string;
};
export type GetTransactionQrCodeApiResponse = string;
export type GetTransactionQrCodeApiArg = {
  transactionId: string;
};
export type GetUserPairedDevicesListApiResponse = UserPairedDeviceListResponseBody;
export type GetUserPairedDevicesListApiArg = void;
export type RefreshEsignoTransactionApiResponse = unknown;
export type RefreshEsignoTransactionApiArg = {
  transactionId: string;
};

export type GetSignableDocumentListApiArg = {
  files: string[];
};
export type GetSignableDocumentListApiResponse = GetSignableDocumentListResponseBody[];

export type GetSignableDocumentListResponseBody = {
  sourceFileId: string;
  pdfFileId: string;
  documentType: string;
  createdAt: string;
  createdBy: string;
  filename: string;
  state: 'created' | 'signed' | 'failed';
  signedDocument: {
    signedDocumentFileId: string;
    auditDocumentFileId: string;
    signedAt: string;
  } | null;
  metadata: {
    id: string;
    title: string;
    signatoryPerson: string;
  }[];
};
export type SignDocumentLocallyApiResponse = {
  id: string;
};
export type SignDocumentLocallyApiArg = {
  sessionName: string;
  files: string[];
  pairedDeviceId?: string | null;
};
export type SignDocumentRemotelyApiResponse = {
  id: string;
};

export type DeviceState = 'unpaired' | 'paired' | 'inactive';

export type RemoteFileSignatureBody = {
  fileId: string;
  signatoryPersons: SignatoryPersonRequestBody[];
};

export type SignDocumentRemotelyApiArg = {
  sessionName: string;
  files: RemoteFileSignatureBody[];
};
export type UnpairDeviceApiResponse = unknown;
export type UnpairDeviceApiArg = {
  pairedDeviceId: string;
};
export type AssignPairedDeviceRequestBody = {
  branches: string[];
};
export type ConfigurationProfileMetadataResponseBody = {
  id: string;
  title: string;
  width: number;
  height: number;
};
export type ConfigurationProfileResponseBody = {
  configurationProfileId: string;
  metadata: ConfigurationProfileMetadataResponseBody[];
};

export type PairedDeviceResponseBody = {
  pairedDeviceId: string;
  pairId: string;
  name: string;
  state: DeviceState;
  branches: string[];
};
export type PairDeviceRequestBody = {
  name: string;
  branches: string[];
};
export type SignedDocumentResponseBody = {
  signedDocumentFileId: string;
  auditDocumentFileId: string;
  signedAt: string;
};
export type SignableDocumentSignatureMetadataResponseBody = {
  id: string;
  title: string;
  signatoryPerson: string;
};
export type SignableDocumentResponseBody = {
  sourceFileId: string;
  pdfFileId: string;
  documentType: string;
  createdAt: string;
  state: 'created' | 'signed' | 'failed';
  signedDocument: SignedDocumentResponseBody | null;
  metadata: SignableDocumentSignatureMetadataResponseBody[];
};
export type SignableDocumentTransactionResponseBody = {
  transactionId: string;
  sessionId: string;
};
export type TransactionMetadataResponseBody = {
  id: string;
  email: string | null;
  phone: string | null;
  name: string | null;
  title: string | null;
};
export type TransactionResponseBody = {
  transactionId: string;
  userId: string;
  sessionId: string;
  tasks: {
    signedDocumentId: string;
    transactionType: string;
    metadata: TransactionMetadataResponseBody[];
  }[];
};
export type UserPairedDeviceResponseBody = {
  pairedDeviceId: string;
  pairId: string;
  name: string;
  state: 'unpaired' | 'paired' | 'inactive';
};
export type UserPairedDeviceListResponseBody = {
  pairedDevices: UserPairedDeviceResponseBody[];
  selectedDeviceId: string | null;
};

export type SignatoryPersonRequestBody = {
  id: string;
  email: string;
  name: string;
  phoneNumber: PhoneNumber;
};
